import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const handleGetWalletTransaction = async (limit = 10, offset = 0) => {
  const transactionRes = await AxiosGetMethod(
    `org/wallet/transaction?limit=${limit}&offset=${offset}`
  );
  if (transactionRes.status === 200) {
    return transactionRes.data.data;
  } else {
    if (transactionRes?.status === 401) HandleLogout();
    ErrorToast("Can't find wallet transactions");
    return null;
  }
};

export default handleGetWalletTransaction;
